// extracted by mini-css-extract-plugin
export default {"dark":"_404_dark__pxHYG","root":"_404_root__PI5NX","wrapper":"_404_wrapper__0DU1S"};